/** Stable short tenant label for lists where names may collide. */
export function tenantLabel(name: string, id: string): string {
  return `${name} (${id.slice(0, 8)})`;
}
